<template>
    <div class="left-huandian">
        <div class="left-box">
            <div class="box-item">
                <div style="width: 30%">{{ leftData.stationNum }}座</div>
            </div>
            <div class="box-item">
                <div style="width: 50%">{{ leftData.totalChargedVehicleNum }}辆</div>
            </div>
            <div class="box-item">
                <div style="width: 70%">{{ leftData.totalChargedElect | unitsWan }}万度</div>
            </div>
            <div class="box-item">
                <div style="width: 90%;">{{ leftData.totalChargedMileage | unitsWan }}万公里</div>
            </div>
            <div class="box-item">{{ leftData.stationType }}</div>
        </div>
        <div class="center-box">
            <div class="box-item">换电站数量</div>
            <div class="box-item">换电车辆数</div>
            <div class="box-item">消费电量</div>
            <div class="box-item">换电里程</div>
            <div class="box-item"></div>
        </div>
        <div class="right-box">
            <div class="box-item">
                <div style="width: 30%">{{ rightData.stationNum }}座</div>
            </div>
            <div class="box-item">
                <div style="width: 50%">{{ rightData.totalChargedVehicleNum }}辆</div>
            </div>
            <div class="box-item">
                <div style="width: 70%">{{ rightData.totalChargedElect | unitsWan }}万度</div>
            </div>
            <div class="box-item">
                <div style="width: 90%;">{{ rightData.totalChargedMileage | unitsWan }}万公里</div>
            </div>
            <div class="box-item">{{ rightData.stationType }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => { return []}
        }
    },
    watch: {
        data(newV) {
            this.leftData = newV[0] || {}
            this.rightData = newV[1] || {}
        }
    },
    data() {
        return {
            leftData: {} ,
            rightData: {} ,
        }
    }
}
</script>

<style lang="scss" scoped>
.left-huandian {
    display: flex;
    font-size: 16px;
    padding-bottom: 20px;
    .left-box, .right-box {
        flex: 1;
        .box-item {
            // background: none;
            display: flex;
            // > div {
            //     height: 100%;
            // }
        }
    }
    .center-box {
        flex-shrink: 0;
        width: 100px;
    }
    .box-item {
        height: 40px;
        margin-top: 30px;
        > div {
            display: flex;
            align-items: center;
        }
    }
    .left-box {
        .box-item {
            justify-content: flex-end;
            > div {
                background: linear-gradient(90deg,  #1bb1de 0%, #094c60  100%);
                border-radius: 20px 0px 0px 20px;
                padding-left: 15px;
            }
            &:last-child {
                position: relative;
                justify-content: flex-start;
                padding-left: 25px;
                align-items: center;
                &::before {
                    position: absolute;
                    content: '';
                    width: 10px;
                    height: 10px;
                    top: 50%;
                    left: 10px;
                    transform: translate(0, -50%);
                    background: linear-gradient(90deg,  #1bb1de 0%, #094c60  100%);
                    border-radius: 50%;
                }
            }
        }
    }
    .center-box {
        .box-item {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .right-box {
        .box-item {
            justify-content: flex-start;
            > div {
                background: linear-gradient(90deg,#3dfff4 0%, #0a3936 100%);
                border-radius: 0px 20px 20px 0px;
                // text-align: right;
                justify-content: flex-end;
                padding-right: 15px;
            }
            &:last-child {
                position: relative;
                padding-right: 25px;
                justify-content: flex-end;
                align-items: center;
                &::before {
                    position: absolute;
                    content: '';
                    width: 10px;
                    height: 10px;
                    top: 50%;
                    right: 10px;
                    transform: translate(0, -50%);
                    background: linear-gradient(90deg,#3dfff4 0%, #0a3936 100%);
                    border-radius: 50%;
                }
            }
        }
    }
}
</style>